import { render, staticRenderFns } from "./DistributionMap.vue?vue&type=template&id=33da2ffc&"
import script from "./DistributionMap.vue?vue&type=script&lang=js&"
export * from "./DistributionMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33da2ffc')) {
      api.createRecord('33da2ffc', component.options)
    } else {
      api.reload('33da2ffc', component.options)
    }
    module.hot.accept("./DistributionMap.vue?vue&type=template&id=33da2ffc&", function () {
      api.rerender('33da2ffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/DataView/Charts/DistributionMap.vue"
export default component.exports